import React from "react";
import { Card, Form, Row, Col, Button, Accordion } from "react-bootstrap";

const DevelopmentSchemesSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleSchemesChange = (type, index, field, value) => {
    const schemes = [...data[type]];
    schemes[index][field] = value;
    handleChange(type, schemes);
  };

  const handleAddScheme = (type) => {
    const schemes = [...data[type]];
    schemes.push({ title: "", points: [""] });
    handleChange(type, schemes);
  };

  const handleRemoveScheme = (type, index) => {
    const schemes = [...data[type]];
    schemes.splice(index, 1);
    handleChange(type, schemes);
  };

  const handlePointChange = (type, schemeIndex, pointIndex, value) => {
    const schemes = [...data[type]];
    schemes[schemeIndex].points[pointIndex] = value;
    handleChange(type, schemes);
  };

  const handleAddPoint = (type, schemeIndex) => {
    const schemes = [...data[type]];
    schemes[schemeIndex].points.push("");
    handleChange(type, schemes);
  };

  const handleRemovePoint = (type, schemeIndex, pointIndex) => {
    const schemes = [...data[type]];
    schemes[schemeIndex].points.splice(pointIndex, 1);
    handleChange(type, schemes);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Development Schemes Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Ongoing Schemes */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6>Ongoing Schemes</h6>
              <Button variant="outline-primary" size="sm" onClick={() => handleAddScheme('ongoingSchemes')}>
                Add Ongoing Scheme
              </Button>
            </div>

            <Accordion>
              {data.ongoingSchemes.map((scheme, index) => (
                <Accordion.Item key={index} eventKey={`ongoing-${index}`}>
                  <Accordion.Header>
                    Ongoing Scheme {index + 1}: {scheme.title || "Untitled"}
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col md={12}>
                        <Form.Control
                          className="mb-3"
                          type="text"
                          placeholder="Scheme title"
                          value={scheme.title}
                          onChange={(e) => handleSchemesChange('ongoingSchemes', index, 'title', e.target.value)}
                        />
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6>Points</h6>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => handleAddPoint('ongoingSchemes', index)}
                      >
                        Add Point
                      </Button>
                    </div>

                    {scheme.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="d-flex gap-2 mb-2">
                        <Form.Control
                          type="text"
                          placeholder="Point"
                          value={point}
                          onChange={(e) => handlePointChange('ongoingSchemes', index, pointIndex, e.target.value)}
                        />
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemovePoint('ongoingSchemes', index, pointIndex)}
                        >
                          ×
                        </Button>
                      </div>
                    ))}

                    <div className="text-end mt-3">
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleRemoveScheme('ongoingSchemes', index)}
                      >
                        Remove Scheme
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>

          {/* New Schemes */}
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6>New Schemes</h6>
              <Button variant="outline-primary" size="sm" onClick={() => handleAddScheme('newSchemes')}>
                Add New Scheme
              </Button>
            </div>

            <Accordion>
              {data.newSchemes.map((scheme, index) => (
                <Accordion.Item key={index} eventKey={`new-${index}`}>
                  <Accordion.Header>
                    New Scheme {index + 1}: {scheme.title || "Untitled"}
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col md={12}>
                        <Form.Control
                          className="mb-3"
                          type="text"
                          placeholder="Scheme title"
                          value={scheme.title}
                          onChange={(e) => handleSchemesChange('newSchemes', index, 'title', e.target.value)}
                        />
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6>Points</h6>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => handleAddPoint('newSchemes', index)}
                      >
                        Add Point
                      </Button>
                    </div>

                    {scheme.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="d-flex gap-2 mb-2">
                        <Form.Control
                          type="text"
                          placeholder="Point"
                          value={point}
                          onChange={(e) => handlePointChange('newSchemes', index, pointIndex, e.target.value)}
                        />
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemovePoint('newSchemes', index, pointIndex)}
                        >
                          ×
                        </Button>
                      </div>
                    ))}

                    <div className="text-end mt-3">
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleRemoveScheme('newSchemes', index)}
                      >
                        Remove Scheme
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default DevelopmentSchemesSection;
